import { emailRegExp, ERROR_EMAIL_EMPTY } from '../../constants';

export function validateForm(values) {
  const errors = {};

  if (!emailRegExp.test(values.email)) {
    errors.email = ERROR_EMAIL_EMPTY;
  }

  return errors;
}
